import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Auth.css';

function Register() {
  const [userData, setUserData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    language: 'ru'
  });
  const [passwordError, setPasswordError] = useState('');
  const { register, error, loading } = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData(prev => ({
      ...prev,
      [name]: value
    }));

    // Проверка совпадения паролей при вводе
    if (name === 'confirmPassword' || name === 'password') {
      if (name === 'confirmPassword' && value !== userData.password) {
        setPasswordError('Пароли не совпадают');
      } else if (name === 'password' && value !== userData.confirmPassword && userData.confirmPassword) {
        setPasswordError('Пароли не совпадают');
      } else {
        setPasswordError('');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Проверка совпадения паролей перед отправкой
    if (userData.password !== userData.confirmPassword) {
      setPasswordError('Пароли не совпадают');
      return;
    }

    // Удаляем confirmPassword, т.к. он не нужен для API
    const { confirmPassword, ...dataToSend } = userData;
    
    await register(dataToSend);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Регистрация</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Имя пользователя:</label>
            <input
              type="text"
              id="username"
              name="username"
              value={userData.username}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={userData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Пароль:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={userData.password}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Подтвердите пароль:</label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={userData.confirmPassword}
              onChange={handleChange}
              required
            />
            {passwordError && <div className="error-message">{passwordError}</div>}
          </div>

          <button 
            type="submit" 
            className="auth-button" 
            disabled={loading || passwordError}
          >
            {loading ? 'Загрузка...' : 'Зарегистрироваться'}
          </button>
        </form>
        
        <div className="auth-links">
          <p>
            Уже есть учетная запись? <Link to="/login">Войти</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Register;
